<template>
  <div id="cookies-policy" class="cookies-policy" v-html="cookies">
  </div>
</template>

<script>
import Axios from 'axios';
import tagFunctions from '@/utils/tagFunctions.js'
export default {
  name: "Cookies",
  props: {
    name: {
      type: String,
      default: "cuamoc.com.mx",
    },
  },
  data() {
    return {
      cookies: '',
    }
  },
  async mounted() {
    tagFunctions.user_interactionPush(
      "view",
      "politica de cookies",
      "footer"
    );
    let serviceResponse = await Axios.get('https://api-mx-marketing.azure-api.net/sitios/cookies/aviso/V1')
    this.cookies = serviceResponse.data.replace('{', '').replace('"body":"', '').replace(`";`, '').replace(`}`, '').replace(`}`, '')
  }
};
</script>
<style lang="scss" >
.cookies-policy {
  font-family: "TerminaMedium" !important;
  font-size: 0.9rem !important;
  margin-right: 12.2pt !important;
  text-align: justify !important;

  h3,
  p {
    margin: 2em 0 1em 0;
  }

  * {
    font-family: "TerminaMedium" !important;
    font-size: 0.9rem !important;
  }

  table,
  tr,
  th,
  td {
    border: 1px solid black;
    border-collapse: collapse;
    font-size: 0.8vw !important;
  }
}

@media screen and (max-width: 768px) {

  .cookies-policy {
    font-size: 0.6rem !important;

    * {
      font-family: "TerminaMedium" !important;
      font-size: 0.8rem !important;
    }

    table,
    tr,
    th,
    td {
      border: 1px solid black;
      border-collapse: collapse;
      font-size: 0.35rem !important;
    }
  }
}
</style>